(function($){

	var isHome = document.body.classList.contains('home'),
		isPage = document.body.classList.contains('page'),
		isMobile = 'ontouchstart' in window,
		isSafari = /apple/i.test(navigator.vendor),
//		hasLazy = 'loading' in HTMLImageElement.prototype,
		
		//isPortrait = window.matchMedia("(orientation: portrait)").matches,

		animationBaseTime = getComputedStyle(document.documentElement).getPropertyValue('--atime'),
		
		announcementContainer = $('.announcement__container'),
		announcements = announcementContainer.find('.announcement'),
		
		sixMaps = $('.sixsquare-map'),
		//sliders = $('.slickSlider'),
		sliders = $('.swiper:not(.no-init)'),
		infoCovers = $('.sixsquare-info-tree-hier.cover'),
		touchhover = $('.touchhover'),
		scrollUp = $('.scroll-up'),
		scrollDown = $('.scroll-down'),
		footerBG = $('.footer-bg')[0],
		footerBGtop = 0,
		
		banner = $('#site-banner'),
		header = $('header.header').first(),
		headerHero = $('.header-hero').first(),
		headerVideo = headerHero.find('video'),
		contentContainer = $('.off-canvas-content > .content'),
		
		headerTitle = $('.header-hero .title__container .title__innerContainer'),
		articleHeader = $('main.main > article header.article-header'),
		articleTitleContainer = articleHeader.children('.title__container'),
		articleTitleContainerInner = articleTitleContainer.children('.title__innerContainer')[0],
		titleContainerHeight = 0,
		titleContainerTop = 0,
		titleBottom = 0,

		scrollAnimates,
		scrollAnimatesList = [],//['.wp-block-media-text'],
		
		slickSliderGrabY = 0,
		slickSliderGrabX = 0,
		slickSliderGrabInhibit = false,
		
		raf_latestKnownScrollY = 0,
		raf_ticking = false,
		
		headerVideoPause =
		headerVideoPlay = function(){},
		
		megaVideoTries = null,
		contentTop = 0,
		windowWidth = 0,
		windowHeight = 0,
		headerHeight = 0;
		
	// pick random slide if class set on slider: randomInitialSlide
	var rSliders = document.getElementsByClassName('randomInitialSlide');
	if ( rSliders.length ) {
		[...rSliders].forEach( s => {
			c = s.children;
			if ( c.length ) {
				c[Math.round( Math.random() * ( c.length - 1 ) )].classList.add('initialSlide');		
			}
		} );
	}
	
	// Set Page Measurements
	var setMeasurements = function () {
		// Set default VH unit for mobile (Safari toolbar full height fix)
		if ( window.innerWidth != windowWidth ) {
			windowWidth = window.innerWidth;
			
			var vh = window.innerHeight * 0.01; // First we get the viewport height and we multiple it by 1% to get a value for a vh unit
			document.documentElement.style.setProperty('--vh', `${vh}px`);
		}
		
		windowHeight = window.innerHeight;
//		raf_latestKnownScrollY = window.scrollY;
		
		//		isPortrait = window.matchMedia("(orientation: portrait)").matches;
		
		if ( headerHero.length ) {
			contentTop = headerHero.outerHeight();
		} else {
			contentTop = header.outerHeight();
		}
				
		if ( header.length ) {
			headerHeight = header.outerHeight();
			if ( banner.length ) banner.height( banner.children('.message')[0].scrollHeight );
		} else {
			headerHeight = 20;
		}
		
		if ( footerBG ) footerBGtop = footerBG.offsetTop;
		
		if ( headerTitle.length ) titleBottom = parseFloat(headerTitle.css('top').replace("px","")) + headerTitle.outerHeight();
		if ( articleTitleContainer.length ) {
			titleContainerHeight = articleTitleContainer.height();
			titleContainerTop = articleTitleContainer.offset().top;
		}

	};
	var IO = window.IntersectionObserver || null;
	
	// Scroll items
	var setScrollItems = function () {	
		if ( scrollAnimatesList.length && !scrollAnimates ) {
			scrollAnimates = [];

			$.each(scrollAnimatesList,function(i,v) {
				var els = $(v);
				if ( els.length ) {
					els = $.map( els.toArray(), function( n, i ){
						n.dataset.saIndex = i;
						return {el: n, top: null, height: null, visible: null, class: [...n.classList]}
					});
					scrollAnimates = $.merge(scrollAnimates,els);
				}
			});
			
			$.each( scrollAnimates,function(i,t){ ioScrollItem.observe(t.el); });
		}
	};
	
	//
	let ioScrollItem = new IO( function(entries) {				//								console.log(`IO called and ended `); console.log(entries);
		$.each(entries,function(ii,entry) {
			var index = null;
/*
var startTime = window.performance.now()
			$.each(scrollAnimates,function(i,v){
				if ( v.el == entry.target ) index = i;
			});
var endTime = window.performance.now()
console.log(`each scrollAnimates took ${endTime - startTime} milliseconds`);
startTime = window.performance.now()
			 index = entry.target.dataset.saIndex;
endTime = window.performance.now()
console.log(`dataset took ${endTime - startTime} milliseconds (${index})`);
*/
			index = entry.target.dataset.saIndex;
			if ( index > -1 ) {
				scrollAnimates[index].visible = entry.isIntersecting;
				scrollAnimates[index].top = entry.boundingClientRect.top + raf_latestKnownScrollY;
				scrollAnimates[index].height = entry.boundingClientRect.height;
			}
		});
	}, {threshold: [0.00,0.01]});

	// Intersection Observer	
	var observer = new IO(function(entries) {
		for(let i=0; i < entries.length; i++) {
			// entries[i]['intersectionRatio']
			// entries[i]['isIntersecting']
			// entries[i]['target']
			if ( entries[i]['isIntersecting'] === true ) {
				entries[i]['target'].classList.remove('pre-init');
			}
		}
	}, { threshold: [0.8] }); 					// Example use: timelineContainer.children('.date').each(function() { observer.observe(this); } );
			
$(document).ready(function() {
	setScrollItems();
	setMeasurements();
	
	// Set CSS Vars
	// Pick random palette
	if ( typeof sixScript.footColors == 'object' && sixScript.footColors.length ) {
		var ps = sixScript.footColors,
			p = ps[Math.floor(Math.random() * ps.length)];
		
		$.each(p,function(i,v) {
			document.documentElement.style.setProperty('--footC' + (1+i), v);
		});
	}
	
	// SVG load
	$('img.svg-load').each( function() { 
		var $img = $(this);
		var imgID = $img.attr('id');
		var imgClass = $img.attr('class');
		var imgURL = $img.attr('src');
		$.get({
			url: imgURL,
			cache: true,
			dataType: 'xml',
			success: function (data) {
				// Get the SVG tag, ignore the rest
				var $svg = $(data).find('svg');
				// Add replaced image's ID to the new SVG
				if(typeof imgID !== 'undefined') {
					$svg = $svg.attr('id', imgID);
				}
				// Add replaced image's classes to the new SVG
				if(typeof imgClass !== 'undefined') {
					$svg = $svg.attr('class', imgClass);
				}
				// Remove any invalid XML tags as per http://validator.w3.org
				$svg = $svg.removeAttr('xmlns:a');
				// Replace image with new SVG
				$img.replaceWith($svg);
			}
		});
	});
	
	// Mobile
	if ( isMobile ) document.body.classList.add('is-mobile');
	if ( isSafari ) document.body.classList.add('is-safari');
	
	// Parallax
	//	var parallax = new Rellax('.ll',{speed:1.5})

	// Lazy Load Images
	const limg = $('img.lazy');
	if ( limg.length ) {		
		const limg_intersection = new IO(function(entries) {
			$.each(entries,function(ii,entry) {
				if ( entry.isIntersecting === true ) {
					entry.target.setAttribute('src', entry.target.dataset.src);
					limg_intersection.unobserve(entry.target);
				}
			});
		}, { threshold: [0.35] });
		
		limg
		.on('load', function() { this.classList.add('loaded'); })
		.each(function() { limg_intersection.observe(this); });
	}
	
	// Hide Site Banner if dismissed this session
	if (	banner.length 
		 &&	typeof sessionStorage.bannerClosed == 'string'
		 &&	sessionStorage.bannerClosed == banner.data('aid') 
	   ) {
		
		banner.removeClass('open');
		banner = [];
	   	
	} else {
	
		// Annoucement Close
		banner.find('.close').click(function() {
			banner.addClass('closed');
			sessionStorage.bannerClosed = banner.data('aid');
			banner = [];
		});
	
	}
		
	// Six maps
	if ( sixMaps.length ) {
		const sm_intersection = new IO(function(entries) {
			$.each(entries,function(ii,entry) {
				if ( entry.isIntersecting === true ) {
					sixSquareMapFeatures( $(entry.target) );
					sm_intersection.unobserve( entry.target );
				}
			});
		}, { threshold: [0.55] });
		
		sixMaps.each(function() { sm_intersection.observe(this); });
	}
	
	// Announcements
	if ( announcements.length ) {
		if ( sessionStorage.announcementsClosed && sessionStorage.announcementsClosed.length ) {
			
			var ss = sessionStorage.announcementsClosed.split(','),
				reset = false;
			
			announcements =  $($.grep(announcements,function(el,i) {
				
				if ( ss.indexOf( el.dataset.aid ) > -1 ) {
					$(el).closest('.swiper-slide').remove();
					return false;
				}
				
				return true;
				
			}));
			
		}

		if ( announcements.length > 1 ) {
			new Swiper ( announcementContainer[0],  {
							direction: 'horizontal',
							loop: true,
							allowTouchMove: false,
							speed: 600,
							autoplay: {
								delay: 5000
							}
						} );
		}
		announcementContainer.on("closed.zf",function(e){
			var announcement = $(e.target),
				aid = announcement.data('aid');

			announcements =  $($.grep(announcements,function(el,i) {
				if ( el.dataset.aid == aid ) {
					$('.announcement[data-aid="' + aid + '"]').closest('.swiper-slide').remove();
					return false;
				}
				return true;
			}));
			
			if ( announcements.length > 0 ) announcementContainer[0].swiper.update();
			if ( announcements.length == 1 ) {
				announcementContainer[0].swiper.disable();
			}

		
			if ( aid.length ) {
				var ss = [];
				if ( sessionStorage.announcementsClosed && sessionStorage.announcementsClosed.length ) ss = sessionStorage.announcementsClosed.split(',');
				if ( !ss.indexOf(aid) > -1 ) {
					ss.push(aid);
					sessionStorage.announcementsClosed = ss;
				}
			
			}
		});

		// fade in
		announcementContainer.addClass('ready');
		
		/*		//Orbit pause on click fix
				announcementContainer.find('.orbit-slide').on('click.zf.orbit', function() { 
					var orbit = $(this).closest('.orbit'); 
					setTimeout( function() {
						if ( orbit.data('paused') == true )
							orbit.closest('.orbit').data('clickedOn',false).foundation('geoSync');
					}, 100);
				});
		*/
	}


	// Swiper
	sliders.each(function() {
		var slider = $(this),
			defaults = {
						initialSlide: Math.max(0, slider.children('.slide.initialSlide').index()),
						direction: 'horizontal',
						effect: 'fade',
						centeredSlides: true,
						loop: true,
						allowTouchMove: false,
						speed: 600,
						navigation:{ nextEl: ".swiper-button-next", prevEl: ".swiper-button-prev" },
						autoplay: {
							delay: 3000
						}
					},
			options = this.dataset.options;
		
		if ( slider.hasClass('no-init') ) return;
		
		if ( options ) {
			try {
				options = JSON.parse( options );
				options = $.extend( defaults, options );	
			} catch (e) {
				options = defaults;
				console.log(`Sliders Swiper options fail.`);
			}
		} 
		
		new Swiper ( slider[0], defaults )
	});
	
	/*
	// Slick Slider
	sliders.each(function() {
		var t = $(this),
			initialSlide = Math.max(0,t.children('.slide.initialSlide').index());
		
		t.on('init',function(e,slick){
			var t = $(this),
				h = t.height();
				
			if ( slick.options.centerMode ) t.addClass('centerMode');
			if ( ! t.hasClass('hero') ) t.height(h);
		
		}).on('reInit',function(e,slick) {
			var t = $(this),
				h = t.css('height','').height();
				
				if ( ! t.hasClass('hero') ) t.height(h);
				
		}).on('beforeChange', (event, slick, currentSlide, nextSlide) => {
//			var nextSlide = slick.$slides[nextSlide];

			
		}).on('afterChange', function(event, slick, currentSlide) {
//			var slide = $(event.target).find('.slick-current');
			
		}).slick({
			// Default options
			initialSlide: initialSlide,
			centerPadding: '20%',
			autoplay: true,
			autoplaySpeed: 5000,
			speed: 600,
			responsive: [
				{ 	breakpoint: 1680,
					settings: {
						centerPadding: '15%'
					}
				}
			]
		});
	});
	*/
	
	// Easy Grid Slider
	var gS = $('.gridSlider').data('gridSliderPos',0); 
	$('<button class="gS_prev"></button><button class="gS_next"></button>').appendTo(gS).click(function(){
		var t = $(this);
		var gS = t.parent('.gridSlider');
		var cur = gS.data('gridSliderPos');
		var move = ( t.hasClass('gS_prev') ? -1 : 1 );
		var slides = gS.children('.cell');
		var maxed = ( ( gS.width() - 1 ) > ( slides.last().position().left ) );
		if ( ( ! maxed || move < 0 ) && (cur + move) >= 0 ) {
//			gS.removeClass('gs-' + cur);
//			gS.addClass('gs-' + (cur + move) ).data('gridSliderPos', cur + move);
			gS.data('gridSliderPos', cur + move).css('--gs',cur + move);
		}
	});
		
	// Scroll Down widget
	if ( scrollDown.length && contentTop ) {
		scrollDown.click(function(){
			var t = (contentTop/400) * 800;
			$('html, body').animate({ scrollTop: contentTop }, t, 'easeInQuad');
		});
		/*
		window.scroll({
		  top: contentTop,
		  behavior: 'smooth'
		});
		*/
	}
		
	// Scroll Up widget
	if ( scrollUp.length && contentTop ) {
		scrollUp.on("click", function(){
			var t = Math.min( 1800, Math.round((scrollUp.offset().top/400) * 200) );
			$('html, body').animate({ scrollTop: 0 }, t, 'easeInQuad');
		});
		/*
		window.scroll({
		  top: 0,
		  behavior: 'smooth'
		});
		*/
	}
	
	// Shalom home
	$('.wp-block-group.shalom-feature-callouts > .wp-block-group > .wp-block-group').click(function(){
		const a = this.parentElement.querySelector('a');
		if (a) window.location = a.href;
	});
	
	// Shalom menu
	$('header.header #main-nav li').click(function(e){
		// Ignore clicks on the anchor itself
		if (e.target.tagName.toLowerCase() === 'a') {
		  return;
		}
		const link = e.target.querySelector('a');
		if (link) {
		  window.location.href = link.href;
		}
	})
	
	// Resize with throttle
	$(window).on('resize', Foundation.util.throttle( function (event) {
	
		sliders.each(function() {
			var t = $(this),
				h = t.css('height','').height();
				if ( ! t.hasClass('hero') ) t.height(h);
	
		});
	
		setMeasurements();
		
			
	}, 300) ).resize();

	if ( headerHero.length ) {
		// Watch header hero intersection
		const header_hero_io = new IO(function(entries) {
			$.each(entries,function(ii,entry) {
				/* if ( scrollUp.length ) {
					if ( entry.intersectionRatio == 0 ) {
						scrollUp.addClass('visible');
					} else {
						scrollUp.removeClass('visible');
					}
				} */
				if ( entry.intersectionRatio < 0.85 ) {	//					console.log( `header scrolled at ${entry.intersectionRatio}` );
					header.addClass('scrolled').removeClass('unscrolled');

				}
				else {									//					console.log( `header unscrolled at ${entry.intersectionRatio}` );
					if ( header.hasClass('scrolled') ) header.addClass('unscrolled');
					header.removeClass('scrolled');
					
				}
				if ( entry.intersectionRatio < 0.1 ) {
					header.addClass('overBody');
				} else {
					header.removeClass('overBody');
				}
				if ( entry.intersectionRatio > 0.2 ) {
					headerVideoPlay();
					headerHero.removeClass('outOfView');
				} else {
					headerVideoPause();
					headerHero.addClass('outOfView');
				}
			});
		}, { threshold: [0.01,0.1,0.2,0.85,1] });
		header_hero_io.observe(headerHero[0]);
	}

	// Scrolling with throttle
	$(window).on('scroll', Foundation.util.throttle( function (event) {
	
		var wTop = $(this).scrollTop();
			
//		sixSquareMapCheck();
		
		if ( !document.body.classList.contains('locked') ) {
			/* 
			if ( contentTop ) {
				if ( wTop >= ( contentTop - headerHeight ) ) {
					header.addClass('scrolled').removeClass('unscrolled');
				} else {
					if ( header.hasClass('scrolled') ) header.addClass('unscrolled');
					header.removeClass('scrolled');
				}
			}
				
			if ( scrollDown.length ) {
				if ( scrollDown.offset().top > contentTop ) {
					scrollDown.addClass('collapse');
				} else {
					scrollDown.removeClass('collapse');
				}
			}
			*/
		}
			
	}, 300) );
	
	// Scroll linked effects updater via requestAnimationFrame
	// can be updated to be an array or such of objects
	function raf_update() {
		raf_ticking = false;
		
		var windowBottom = raf_latestKnownScrollY + windowHeight;
		
		if (articleTitleContainer.length && !isHome ) {
			var wAnchor = raf_latestKnownScrollY + titleBottom, // (window.innerHeight * short),
				tcBottom = titleContainerTop + titleContainerHeight; //articleTitleContainer.innerHeight();

			if ( wAnchor > tcBottom ) {
				articleTitleContainerInner.classList.add('stuck')
				//articleTitleContainer.children('.title__innerContainer').addClass('stuck');
			}
			else {
				articleTitleContainerInner.classList.remove('stuck')
//				articleTitleContainer.children('.title__innerContainer').removeClass('stuck');
			}
			
			// Article Header Height animates distance between hero and copy
			if ( raf_latestKnownScrollY >= titleContainerHeight ) {
				articleHeader.css('height','');
			} else {
				articleHeader.css('height',raf_latestKnownScrollY + 'px');
			}
			
		}

		// Scroll Animates
/*		scrollAnimates.each(function(){
			var t = this,
				percent = Math.max( 0, Math.min( 1, (((raf_latestKnownScrollY - t.offsetTop + windowHeight ) / windowHeight) - 0.2 ) * 1.4 ) );

			if ( t.classList.contains('wp-block-media-text') ) {
				$.each(t.children, function(i,c) {
					if ( c.classList.contains('wp-block-media-text__content') ) c.style.opacity = percent;
					else if ( c.classList.contains('wp-block-media-text__media') && t.classList.contains('has-media-on-the-right') ) c.style.transform = "translate("+(100 - percent*100)+"%,"+(100 - percent*100)+"%)";
					else if ( c.classList.contains('wp-block-media-text__media') )  c.style.transform = "translate("+(-100 - percent*-100)+"%,"+(100 - percent*100)+"%)";
					
				});
			}
		}); */
		
		$.each(scrollAnimates, function(i,scrollItem) {
			if ( scrollItem.visible !== false ) {
				var heightPercentageInverse = 1 - ( Math.min(1,(scrollItem.height / windowHeight )) ),
					heightMultiplier = ( heightPercentageInverse > 0 ? heightPercentageInverse + 1 : 1 ),
					percent = Math.max( 0, Math.min( 1, (((raf_latestKnownScrollY - scrollItem.top + windowHeight ) / windowHeight) - 0.2 ) * 1.4 * heightMultiplier ) );
				if ( scrollItem.class.indexOf('wp-block-media-text') > -1 ) {
					$.each(scrollItem.el.children, function(i,c) {
						if ( c.classList.contains('wp-block-media-text__content') ) c.style.opacity = percent;
						else if ( c.classList.contains('wp-block-media-text__media') && scrollItem.el.classList.contains('has-media-on-the-right') ) c.style.transform = "translate("+(100 - percent*100)+"%,"+(100 - percent*100)+"%)";
						else if ( c.classList.contains('wp-block-media-text__media') )  c.style.transform = "translate("+(-100 - percent*-100)+"%,"+(100 - percent*100)+"%)";
						
					});
				}
			}
			// first run, then exclude -- not working, IO goes first
			if ( scrollItem.visible === null ) { scrollItem.visible = false; console.log('nullVisible#####'); }
			
		});

		// Footer BG
		if ( footerBGtop && footerBGtop <= windowBottom ) {
			footerBG.style.opacity = (raf_latestKnownScrollY - footerBGtop + windowHeight ) / windowHeight;	
		}
		
	}
	
	// Scrolling 
	$(window).on('scroll', function (event) {
		
		raf_latestKnownScrollY = window.scrollY;
		if(!raf_ticking) {
		  requestAnimationFrame(raf_update);
		}
		raf_ticking = true;
	
	} ).scroll();
	
	// sixsquare Info Trees
	$('.sixsquare-info-tree .title__container .toggle').click(function() {
		var t = $(this).closest('.sixsquare-info-tree'),
			level = t.data('itl'),
			id = t.data('itid'),
			td = t.find('.details'),
			close = t.hasClass('open'),
			cclass = '.itl' + ( level + 1 ) + 'id' + id,
			c = t.parent().siblings(cclass);
		
		if ( close ) {
			
			if ( c.length ) {
				c.find('.details').css('maxHeight','');
				c.find('.open').addBack().removeClass('open');
			}
		
			t.removeClass('open');
			if ( td.length) td.css('maxHeight','');
			
		} else {
			
			$('.l' + level + 'i.open').each(function() {
				var ithis = $(this);
				// close siblings if they have items
				if ( t.parent().siblings('.itl' + ( ithis.data('itl') + 1 ) + 'id' + ithis.data('itid')).length ) ithis.find('.toggle').click();
			});
			
			if ( c.length ) {
//				c.siblings('.items.open').removeClass('open');
				c.addClass('open').find('.open').removeClass('open');
			}
			
			t.addClass('open');
			if ( td.length) {
				var maxHeight = td[0].scrollHeight,
					tdi = td.find('img.bg').height(),
					maxHeight = ( tdi ? Math.max( tdi, maxHeight ) : maxHeight );
					
				td.css('maxHeight', maxHeight + 'px');
			}
			
			
			
		}
	});
	
	infoCovers.each( function() {
		observer.observe(this);
	}).find('.item').click(function(){
		if ( !this.classList.contains('active') ) {
			var t = $(this);
			t.siblings().removeClass('active');
			t.addClass('active');
			t.closest('.cover').addClass('transition');
			
		}
	}).on('transitionend',function(e) {
		if ( e.target != this || !this.classList.contains('active' ) ){ return; }
		var cover = $(this).closest(infoCovers);
		cover.css('background-image','url(' + this.dataset.backgroundImage + ')');
		cover.removeClass('transition');
	});
	
	
	// CUSTOM CURSOR
	if ( !isMobile ) {
		if ( window.cursor = document.getElementById('cursor') ) {
		
			// move cursor as mouse move
			document.addEventListener("mousemove", (e) => {
			   window.cursor.style.left = e.x + 'px'
			   window.cursor.style.top = e.y + 'px'
			});
		
			// show window.cursor on nav div
			$('.hasCursorNav').hover(
				function() {
					window.cursor.classList.add('visible');
					if ( this.classList.contains('slickSlider') ) window.cursor.classList.add('slick');
				},
				function() {
					window.cursor.classList.remove('visible', 'slick');
				}
			);
				
			// slickSlider
			$('.slickSlider.hasCursorNav .slick-arrow').hover(
				function() {
					if ( this.classList.contains('slick-next') ) window.cursor.classList.add('next');
					else if ( this.classList.contains('slick-prev') ) window.cursor.classList.add('prev');
				},
				function() { window.cursor.classList.remove('next','prev'); }
			);
				
			// TEAM MEMBER PAGE
			$('section.team').find('.photo,.titles').hover(
				function() {
					if ( this.parentNode.classList.contains('open') ) window.cursor.classList.add('visible','less');
					else { 
						window.cursor.classList.add('visible','more');
						window.cursor.classList.remove('less');
					}
				},
				function() { window.cursor.classList.remove('visible','less','more'); }
			);
					
			// catch cursor hovering on PAGE LOAD 
			$(document).one('mousemove',function(){
				if ( $('.hasCursorNav:hover').length ) {
					window.cursor.classList.add('visible');
								
				}
			});
			
		}
		
	}
	
/*	function sixSquareMapCheck() {
		// Google Maps
		if ( sixMaps.length ) {
			sixMaps.each(function(i, el) {
				el = $(el);
				if ( el.visible('middle') ) { 
					sixSquareMapFeatures( el );
					sixMaps = sixMaps.not(this);
				}
			});
		}
	}
*/
	// Top Bar toggle (mobile menu)
	$('header button.menu-icon').click(function() {
		var menu = $('#top-bar-menu');
		if ( menu.hasClass('expanded') ) {
			menu.removeClass('expanded');
			this.classList.remove('open');
		} else {
			menu.addClass('expanded');
			this.classList.add('open');
		}
	});
	
	// Drop Down Menu add animation class. Foundation JS interferes with custom transitions
	$('#main-nav').on('show.zf.dropdownMenu',function(e,$sub){ // returns submenu element
		$sub[0].classList.add('fadein');
	});
	$('#main-nav').on('hide.zf.dropdownMenu',function(e,$sub){ // Returns parent menu element
		$($sub[0]).find('.is-dropdown-submenu').removeClass('fadein');
	});
	
	// Off Canvas links: close on click. This ensures the menu is hidden when navigating back. Reducing the transition was somehow necessary. It is fixed by onClick code in nav-offcanvas-topbar.php. The callback below doesn't get called.
	$('#off-canvas a').click(function(e){
		if ( $(this).parent().hasClass('is-accordion-submenu-parent') ) return true;
		if ( $(this).attr('target') == "_blank" ) return true;
		if ( $(this).parent().hasClass('noclick') ) return false;
		return true;
		var t = $(this);
				
		// don't follow link	
		e.preventDefault();
		
		// Close off-canvas
		$('#off-canvas').foundation('close');
		
		// Trigger body pageLoader
		document.body.classList.add('loading','loading-from-offcanvas');
		
		// follow link after off-canvas closes
		$('#off-canvas').on('closed.zf.offCanvas', function () {
			window.location = t.attr('href');
		});		

		return false;

	});
		
	// Off-Canvas inner: stop propagation of transitionend event causing premature transition on close
	$('.offcanvas-full-screen-inner').on('transitionend',(e)=>e.stopPropagation());

	// Off-Canvas Open [verified]
	$('#off-canvas').on('opened.zf.offCanvas', function (e) {

	//	document.activeElement.blur();
		
		headerVideoPause();

	});
	
	// Off-Canvas Open Ended [verified]
	$('#off-canvas').on('openedEnd.zf.offCanvas', function (e) {
		
//		sixSquareMapCheck();
		document.activeElement.blur();
		bodyScrollLock(true);
		
	});

	// Off-Canvas Close [verified]
	$('#off-canvas').on('close.zf.offCanvas', function (e) {
		setTimeout(function(){
			bodyScrollLock(false);
		},100);
	});
	
	// Off-Canvas Closed [verified]
	$('#off-canvas').on('closed.zf.offCanvas', function (e) {
		bodyScrollLock(false);
		headerVideoPlay();
	});
	
	// Off-Canvas accordion menu OPEN
//	$('#offcanvas-nav').foundation('showAll');
	
	// Touch hover methods
	if ( isMobile ) {
		touchhover.on('touchstart', function(e) {
			var t = $(this);
			
			if ( t.hasClass('hover') ) {
				return true;
			} else {
				t.addClass('hover');
				touchhover.not(this).removeClass('hover');
				e.preventDefault();
				return false;
			}
			
		});
		document.body.addEventListener('touchstart',function(e) {
			touchhover.removeClass('hover');
		});
	}
	
	/* // Load More Posts
	$('.loadMorePosts').each(function(){

		var _t = $(this),
			id = _t.attr('id'),
			winVar = 'loadMorePosts_' + id;
			
		if ( typeof window[winVar] != 'undefined' && window[winVar].current_page && window[winVar].max_page ) {
			$('<span class="button doLoadMorePosts">' + window[winVar].buttonLabel +'</span>')
			.data('lmpID',id)
			.click(function(){nsLoadMorePosts(this);})
			.insertAfter(_t).wrap('<div class="container__loadMoreButton"></div>');
			_t.find('.wp-pagenavi').hide();
		}
		
	});
	
	function nsLoadMorePosts(button){
	//	if ( typeof winVar != 'string' || ! winVar.length ) return;
		
		var button = $(button),
			id = button.data('lmpID'),
			winData = window['loadMorePosts_' + id],
			data = {
				'action': 'sixloadmoreposts',
				'template': winData.template,
				'page' : winData.current_page
			};
 
		$.ajax({ // you can also use $.post here
			url : winData.ajaxurl, // AJAX handler
			data : data,
			type : 'POST',
			beforeSend : function ( xhr ) {
				button.text(winData.buttonLabelLoading + '...'); // change the button text, you can also add a preloader image
			},
			success : function( data ){
				if( data ) { 
					button.text( winData.buttonLabel );
					
			//		$('#' + id).append(data); // insert new posts
					// insert new posts
					var newContent = jQuery(data);
					
					newContent.each(function(){ 
						jQuery(this).hide(); 
					});
					
					newContent.appendTo('#' + id).each(function(i){ 
						jQuery(this).delay(i*250).fadeIn(2500);
					});
					
					winData.current_page++;
 
					if ( winData.current_page == winData.max_page ) button.fadeOut(250); // if last page, remove the button
 
					// $( document.body ).trigger( 'post-load' );
				} else {
					button.remove(); // if no data, remove the button as well
				}
			}
		});
	} */
	

		
}); // document.ready()
$(window).bind("pageshow", function(event) {
	// BODY ANIMATION TRIGGER
	setTimeout(function(){
		document.body.classList.remove('pre-init','loading','loading-from-offcanvas');
		$(window).scroll();
	},200);
});
window.addEventListener('load', function() {
	
	// BODY ANIMATION TRIGGER
	var timeout = 200 + ( window.ssStart && ((Date.now() - window.ssStart)) < 4000 ? 1500 : 0 );
	setTimeout(function(){
		document.body.classList.remove('pre-init','loading','loading-from-offcanvas');
		$(window).scroll();
	}, timeout);	
	
	// Homepage Video
	if ( headerVideo.length ) {	
	
		if ( null == headerVideo.attr('src') ) {
			// lazy load video
			headerVideo.attr('src', headerVideo.data('src'));
			headerVideo[0].load();
		}
		
		headerVideoPlay = function () {
		
			if ( 
				!header.hasClass('overBody') &&
				(
					headerVideo[0].paused 
					|| !headerVideo[0].parentNode.classList.contains('videoplay') 
				)
			) {
		
				var promise = headerVideo[0].play();
			
				if (promise !== undefined) {
					promise.catch(error => {
						// Auto-play was prevented
						// Show a UI element to let the user manually start playback
											console.log('HOME VIDEO FAIL ' + megaVideoTries);
						if ( megaVideoTries < 3 ) {
							megaVideoTries++;
							if ( megaVideoTries == 2 ) {
								headerVideo[0].setAttribute('controls',true);
								headerVideo[0].parentNode.classList.add('videoplay');
							}
							setTimeout(function(){
								headerVideoPlay();
							},400);
						}
					}).then(() => {
						// Auto-play started
												console.log('VIDEO PLAYING');
						headerVideo[0].parentNode.classList.add('videoplay');
					});
				}
				
			}
		
		}
		
		headerVideoPause = function () {
			headerVideo[0].pause();
		}
		
		headerVideoPlay();
	
	}

	
});

// Breakpoint Change
$(window).on('changed.zf.mediaquery ready', function(event, newSize, oldSize) {
	if ( typeof newSize == 'undefined' ) newSize = Foundation.MediaQuery.current;

	if ( newSize == 'small' ) {
		
	} else if ( oldSize == 'small' ) {

	} 
	if ( newSize && oldSize ) { // actual change, not first call (ready)
		
		// Easy Grid Slider reset
		$('.gridSlider').each( function() {
			var gS = $(this);
			var cur = gS.data('gridSliderPos');
//			gS.removeClass('gs-' + cur).data('gridSliderPos',0);
			gS.data('gridSliderPos',0).css('--gs',0);
		});
		
	}
});


// Gravity Forms: FORM POST RENDER (This includes initial form load, going to the next/previous page on multi-page forms, form rendered with validation errors, confirmation message displayed, etc.)
$(document).bind('gform_post_render', function(event,formID){
	
	// Button Style clicks and check
	jQuery('#gform_wrapper_' + formID + ' .gf_button_style .ginput_container .gfield_radio .gchoice').click(function(){
		var t = jQuery(this),
			i = t.children('input'),
			val = i.val(),
			all = t.siblings('.gchoice');
	
		all.removeClass('checked').children('input').prop('checked',false);
		i.prop('checked',true).change();
		t.addClass('checked');
	
	}).each( function() {
	
		if ( jQuery(this).children('input').is(':checked') ) {
			jQuery(this).addClass('checked');
		}
	
	});
	
});
		
// fn: Visible
$.fn.visible = function(type) {
	var t            = $(this);
	if ( typeof t.offset() != "object" ) { console.log('visible: not object.'); console.log(this); return false; }
	var	$w            = $(window),
		viewTop       = $w.scrollTop(),
		viewBottom    = viewTop + $w.height(),
		_height		  = t.height(),
		offset        = t.offset(),
		_top          = offset.top,
		_middle		  = _top + (_height/2),
		_bottom       = _top + _height,
		_10			  = _height*0.1;
		
		if ( offset.left <= (0 - t.width()) || offset.left > $w.width() ) return false;
		
		switch (type) {
			case 'top': return (_top +_10 >= viewTop) && (_top < viewBottom);
			case 'middle': return (_middle >= viewTop) && (viewBottom >= _middle);
			//case 'full':
			default: return (_bottom <= viewBottom) && (_top >= viewTop);
		}
};

// Body Scroll Lock
var scrollPosition = 0;

// this has a big bug on ios beacuse of the status bar. The space is taken up by a white box that is not usable.
function bodyScrollLock(lock) { if ( isMobile ) return;
	if ( lock ) {

		scrollPosition = window.pageYOffset;
		document.body.classList.add('locked');
		document.body.style.overflow = 'hidden';
		document.body.style.position = 'fixed';
		document.body.style.top = `-${scrollPosition}px`;
		document.body.style.width = '100%';
		
	} else {
		
		document.body.style.removeProperty('overflow');
		document.body.style.removeProperty('position');
		document.body.style.removeProperty('top');
		document.body.style.removeProperty('width');
		window.scrollTo(0, scrollPosition);
		document.body.classList.remove('locked');

	}
}

// grab
// Example useage: if ( !isMobile ) timelineContainer.on('mousedown', grabMouseDown);
var grab = { top: 0,
			left: 0,
			x: 0,
			y: 0,
			snapUnset: ((typeof InstallTrigger !== 'undefined') || (!!window.chrome && (!!window.chrome.webstore || !!window.chrome.runtime))), // Unset scrollsnap for Firefox and Chrome
			el: null
		},
grabMouseDown = function(e) {
	var t = jQuery(this);
    grab = {
        // The current scroll 
        left: this.scrollLeft,
        top: this.scrollTop,
        // Get the current mouse grabition
        x: e.clientX,
        y: e.clientY,
        snapUnset: grab.snapUnset,
        el: this
    };
    
    // Change the cursor and prevent user from sgrab.elcting the text
    grab.el.style.cursor = 'grabbing';
	grab.el.style.userSelect = 'none';
	if ( grab.snapUnset ) grab.el.style.scrollSnapType = 'unset';

    document.addEventListener('mousemove', grabMouseMove);
    document.addEventListener('mouseup', grabMouseUp);
},
grabMouseMove = function(e) {
    // How far the mouse has been moved
    const dx = e.clientX - grab.x;
    const dy = e.clientY - grab.y;

    // Scroll the grab.elment
    grab.el.scrollTop = grab.top - dy;
    grab.el.scrollLeft = grab.left - dx;
},
grabMouseUp = function() {
    grab.el.style.removeProperty('cursor');
    grab.el.style.removeProperty('user-select');
    if ( grab.snapUnset ) grab.el.style.removeProperty('scroll-snap-type');
    
    document.removeEventListener('mousemove', grabMouseMove);
    document.removeEventListener('mouseup', grabMouseUp);
};

// Google Maps Callback fn
window.sixSquareMapInit = function () {
	// Create a new StyledMapType object, passing it an array of styles,
	// and the name to be displayed on the map type control.
	var styledMapType = new window.google.maps.StyledMapType([
	  {
		"elementType": "geometry",
		"stylers": [{
			"color": "#f5f5f5"
		  }]
	  },
	  {
		"elementType": "labels.icon",
		"stylers": [{
			"visibility": "off"
		  }]
	  },
	  {
		"elementType": "labels.text.fill",
		"stylers": [{
			"color": "#616161"
		  }]
	  },
	  {
		"elementType": "labels.text.stroke",
		"stylers": [{
			"color": "#f5f5f5"
		  }]
	  },
	  {
		"featureType": "administrative.land_parcel",
		"elementType": "labels.text.fill",
		"stylers": [{
			"color": "#bdbdbd"
		  }]
	  },
	  {
		"featureType": "poi",
		"elementType": "geometry",
		"stylers": [{
			"color": "#eeeeee"
		  }]
	  },
	  {
		"featureType": "poi",
		"elementType": "labels.text",
		"stylers": [{
			"visibility": "off"
		  }]
	  },
	  {
		"featureType": "poi",
		"elementType": "labels.text.fill",
		"stylers": [{
			"color": "#757575"
		  }]
	  },
	  {
		"featureType": "poi.business",
		"stylers": [{
			"visibility": "off"
		  }]
	  },
	  {
		"featureType": "poi.business",
		"elementType": "labels.text",
		"stylers": [{
			"visibility": "off"
		  }]
	  },
	  {
		"featureType": "poi.park",
		"elementType": "geometry",
		"stylers": [{
			"color": "#e5e5e5"
		  }]
	  },
	  {
		"featureType": "poi.park",
		"elementType": "labels.text.fill",
		"stylers": [{
			"color": "#9e9e9e"
		  }]
	  },
	  {
		"featureType": "road",
		"elementType": "geometry",
		"stylers": [{
			"color": "#ffffff"
		  }]
	  },
	  {
		"featureType": "road",
		"elementType": "labels.icon",
		"stylers": [{
			"visibility": "off"
		  }]
	  },
	  {
		"featureType": "road.arterial",
		"elementType": "labels.text.fill",
		"stylers": [{
			"color": "#757575"
		  }]
	  },
	  {
		"featureType": "road.highway",
		"elementType": "geometry",
		"stylers": [{
			"color": "#dadada"
		  }]
	  },
	  {
		"featureType": "road.highway",
		"elementType": "labels.text.fill",
		"stylers": [{
			"color": "#616161"
		  }]
	  },
	  {
		"featureType": "road.local",
		"elementType": "labels.text.fill",
		"stylers": [{
			"color": "#9e9e9e"
		  }]
	  },
	  {
		"featureType": "transit",
		"stylers": [{
			"visibility": "off"
		  }]
	  },
	  {
		"featureType": "transit.line",
		"elementType": "geometry",
		"stylers": [{
			"color": "#e5e5e5"
		  }]
	  },
	  {
		"featureType": "transit.station",
		"elementType": "geometry",
		"stylers": [{
			"color": "#eeeeee"
		  }]
	  },
	  {
		"featureType": "water",
		"elementType": "geometry",
		"stylers": [{
			"color": "#80bac5"
		  }]
	  },
	  {
		"featureType": "water",
		"elementType": "labels.text.fill",
		"stylers": [{
			"color": "#9e9e9e"
		  }]
	  }
	], {name: 'Styled Map'});
	
	sixMaps.each(function() {
		const $mapEl = $(this);
		const rawCoords = $mapEl.data('coordinates');
		const coordinates = Array.isArray(rawCoords) ? rawCoords : [];
		
		let center = {};
		
		if ( coordinates.length ) {
			// coordinates embedded in map data- attribute
			center = coordinates[0]; // center map on first coordinate
		} else {
			 // global default map
			center = {
				lat: window.sixScript.gmap_lat,
				lng: window.sixScript.gmap_long
			};
		}
		
		if ( !center || !center.lat || !center.lng ) return;
		
		var googleMap = new window.google.maps.Map( this, {
			zoom: 15,
			center: new window.google.maps.LatLng( center.lat, center.lng ),
			mapTypeId: 'roadmap',
			zoomControl: true,
			mapTypeControl: false,
			fullscreenControl: false,
			streetViewControl: false,
			scrollwheel: false
		});

		//Associate the styled map with the MapTypeId and set it to display.
		googleMap.mapTypes.set('styled_map', styledMapType);
		googleMap.setMapTypeId('styled_map');
		
		$mapEl.data('gmap', googleMap);
	
	});

}
// Google Maps Feature / pin / display fn
function sixSquareMapFeatures( map ) {

	if ( typeof map != 'object' || typeof window.google != 'object' ) return false;
	
	var googleMap = map.data('gmap');
	if (!googleMap) return;

	if ( typeof map.data('gmapMarkers') == 'undefined' ) {
		// First init!
		map.data('gmapMarkers', []);
		
		const rawCoords = map.data('coordinates');
		const coordinates = Array.isArray(rawCoords) ? rawCoords : [];
		
		if ( ! coordinates.length ) {
			 // global default map
			coordinates.push({
				lat: window.sixScript.gmap_lat,
				lng: window.sixScript.gmap_long,
				pid: window.sixScript.gmap_placeid
			});
		}
		
		if ( !coordinates.length || !coordinates[0].lat || !coordinates[0].lng ) return;

		var icon = {
			url: window.sixScript.gmap_icon,
			scaledSize: new window.google.maps.Size(33,46),
//			origin: new google.maps.Point(0,0),
			anchor: new window.google.maps.Point(16,46)
		};
		
		coordinates.forEach((feature, i) => {
			const position = new window.google.maps.LatLng(feature.lat, feature.lng);
			const title = feature.title || undefined;
		
			const marker = new window.google.maps.Marker({
				position: position,
				map: googleMap,
				icon: icon,
				animation: window.google.maps.Animation.DROP,
				title: title,
				clickable: true
			});
		
			marker.addListener('click', function () {
				const destination = ( feature.pid ? feature.pid : `${feature.lat},${feature.lng}` );
				const pid = ( feature.pid ? feature.pid : `` );
				const url = `https://www.google.com/maps/dir/?api=1&destination=${destination}&destination_place_id=${pid}`;
				window.open(url);
			});
		
			map.data('gmapMarkers').push(marker);
		});

	} else {

		// reinit
		const markers = map.data('gmapMarkers');
		if (markers.length > 0) {
			markers[0].setAnimation(window.google.maps.Animation.DROP);
			googleMap.setCenter(markers[0].getPosition());
		}
		
	}
	
}

// jQuery Easings
$.extend( $.easing, {
	easeOutCubic: function (x, t, b, c, d) {
			return c*((t=t/d-1)*t*t + 1) + b;
		},
	easeInQuad: function (x, t, b, c, d) {
	    return c*(t/=d)*t + b;
	},
});


})(jQuery);